"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecretViewDetails = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _RenderDynamicFields = require("./RenderDynamicFields");

var _lodash = require("lodash");

var _SecretNameRenderer = require("./SecretNameRenderer");

var _SecretDescRenderer = require("./SecretDescRenderer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecretViewDetails = function SecretViewDetails(_ref) {
  var secretDetailData = _ref.secretDetailData,
      secretTemplateData = _ref.secretTemplateData,
      file = _ref.file,
      secretFileDownloadStatus = _ref.secretFileDownloadStatus,
      secretFileDownloadStatusCode = _ref.secretFileDownloadStatusCode,
      reloadSecretFile = _ref.reloadSecretFile,
      fetchNewOTP = _ref.fetchNewOTP,
      otp = _ref.otp,
      secretOTPFetchStatus = _ref.secretOTPFetchStatus,
      secretOTPFetchError = _ref.secretOTPFetchError,
      secretDetailsLoadTime = _ref.secretDetailsLoadTime,
      secretTemplateLoadTime = _ref.secretTemplateLoadTime,
      secretOTPFetchLoadTime = _ref.secretOTPFetchLoadTime;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretViewLayout
  }, secretDetailData && /*#__PURE__*/_react.default.createElement(_SecretNameRenderer.SecretNameRenderer, {
    secretDetailData: secretDetailData
  }), secretDetailData && /*#__PURE__*/_react.default.createElement(_SecretDescRenderer.SecretDescRenderer, {
    secretDetailData: secretDetailData
  }), !(0, _lodash.isEmpty)(secretTemplateData) && /*#__PURE__*/_react.default.createElement(_RenderDynamicFields.RenderDynamicFields, {
    secretTemplateData: secretTemplateData,
    secretDetailData: secretDetailData,
    file: file,
    secretFileDownloadStatus: secretFileDownloadStatus,
    secretFileDownloadStatusCode: secretFileDownloadStatusCode,
    reloadSecretFile: reloadSecretFile,
    fetchNewOTP: fetchNewOTP,
    otp: otp,
    secretOTPFetchStatus: secretOTPFetchStatus,
    secretOTPFetchError: secretOTPFetchError,
    secretDetailsLoadTime: secretDetailsLoadTime,
    secretTemplateLoadTime: secretTemplateLoadTime,
    secretOTPFetchLoadTime: secretOTPFetchLoadTime
  })));
};

exports.SecretViewDetails = SecretViewDetails;
SecretViewDetails.propTypes = {
  secretDetailData: _propTypes.default.object,
  secretTemplateData: _propTypes.default.object,
  file: _propTypes.default.object,
  secretFileDownloadStatus: _propTypes.default.string,
  secretFileDownloadStatusCode: _propTypes.default.number,
  reloadSecretFile: _propTypes.default.func,
  fetchNewOTP: _propTypes.default.func,
  otp: _propTypes.default.string,
  secretOTPFetchStatus: _propTypes.default.string,
  secretOTPFetchError: _propTypes.default.string,
  selectedItemAncestors: _propTypes.default.array,
  secretDetailsLoadTime: _propTypes.default.number,
  secretTemplateLoadTime: _propTypes.default.number,
  secretOTPFetchLoadTime: _propTypes.default.number
};